import app from 'firebase/app/';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/functions';
//import 'firebase/remoteconfig';
import development from '@barokah-group/development'

const prodConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
};

const developmentMode=false
const config = prodConfig.apiKey === undefined || developmentMode ? development : prodConfig;

class Firebase {
  constructor() {
    //window.alert(process.env.REACT_APP_API_KEY);
    app.initializeApp(config);
    
    this.auth = app.auth();
    this.db = app.database();
    this.fs = app.firestore();
    this.fn = app.functions();
    this.functions=this.fn
    this.st= app.storage();
    this.storage=this.st
  }

  // *** Auth API ***

  doCreateUserWithEmailAndPassword = (email, password) =>
    this.auth.createUserWithEmailAndPassword(email, password);

  doSignInWithEmailAndPassword = (email, password) =>
    this.auth.signInWithEmailAndPassword(email, password);

  doSignInWithPhone = (phone, password) =>
    this.auth.signInWithPhoneNumber(phone,null);

  doSetPersistence =(persistenceMode)=>
    this.auth.setPersistence(persistenceMode==="local"||persistenceMode==="session"||persistenceMode==="none"?persistenceMode:"local")

  doSignOut = () => this.auth.signOut();

  doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

  doPasswordUpdate = password =>
    this.auth.currentUser.updatePassword(password);


  // *** User API Realtime Database***

  user = uid => this.db.ref(`users/${uid}`);

  users = () => this.db.ref('users');

   // *** Firestore API ***

  getFsDoc = (path) => this.fs.doc(path);
  getFsCol = (path) => this.fs.collection(path);

  listenFsCol=(path)=> this.fs.collection(path);



}

export default Firebase;